module.exports = __webpack_public_path__ + "media/images/tyre-guide-large-6cdd47d63cb41060ccaa6b38c8eb4385.jpg";